<template>
  <div>
    <h1>Game Setting</h1>
    <div class="primary--text my-2 ml-1" style="color: black">Campaign</div>
    <v-divider class="my-3"></v-divider>
    <div style="display: flex">
      <template v-for="status in ['Draft', 'Active', 'Publish', 'Inactive']">
        <v-checkbox
          :key="status"
          v-model="filter.status"
          color="primary"
          :value="status"
          :label="status"
        ></v-checkbox>
      </template>
    </div>
    <div style="display: flex; flex-direction: row; justify-content: space-between">
      <v-flex class="mx-0" style="width: max-content; flex: 0">
        <v-btn
          class="mx-0"
          color="primary"
          :outline="showAdvanceSearch"
          @click="showAdvanceSearch = !showAdvanceSearch"
        >
          <v-icon class="mr-2">manage_search </v-icon>
          {{ $t('advanced search') }}
        </v-btn>
      </v-flex>
      <v-flex class="mx-0" style="width: max-content; flex: 0; white-space: nowrap">
        <v-btn outline @click="showListSort = true">Sort</v-btn>
        <v-btn class="mx-0" color="primary" @click="handleCreateCampaign">
          <v-icon class="mr-2">add</v-icon> {{ $t('Add') }}
        </v-btn>
      </v-flex>
    </div>
    <div
      v-if="showAdvanceSearch"
      class="pa-2 my-2"
      style="border: 1px solid #eee; border-radius: 10px"
    >
      <v-layout wrap>
        <v-flex xs12 sm3 class="px-1">
          <div class="caption mb-2">Campaign Name</div>
          <v-text-field
            v-model="filter.name"
            class="default-input"
            outline
            hide-details
            single-line
            placeholder="Campaign Name"
          ></v-text-field>
        </v-flex>
        <v-flex xs12 sm3 class="px-1">
          <div class="caption mb-2">Game</div>
          <v-select
            v-model="filter.game_type"
            :items="['Spinning Wheel', 'Box Prize']"
            placeholder="Game"
            outline
            class="default-input"
            hide-details
            dense
            single-line
            clearable
          ></v-select>
        </v-flex>
        <v-flex xs12 sm6>
          <div class="caption mb-2">Campaign Period</div>
          <v-layout wrap>
            <v-flex xs12 sm6 class="px-1">
              <DatepickerCustomDialog v-model="filter.campaign_period_from">
                <template #default="{ computedDate }">
                  <v-text-field
                    class="default-input"
                    outline
                    name="startDate"
                    readonly
                    :value="computedDate"
                    hide-details
                    single-line
                    clearable
                    :placeholder="$t('from')"
                    @click:clear="filter.campaign_period_from = undefined"
                  ></v-text-field>
                </template>
              </DatepickerCustomDialog>
            </v-flex>
            <v-flex xs12 sm6 class="px-1">
              <DatepickerCustomDialog v-model="filter.campaign_period_to">
                <template #default="{ computedDate }">
                  <v-text-field
                    class="default-input"
                    outline
                    name="startDate"
                    readonly
                    :value="computedDate"
                    hide-details
                    single-line
                    clearable
                    :placeholder="$t('to')"
                    @click:clear="filter.campaign_period_to = undefined"
                  ></v-text-field>
                </template>
              </DatepickerCustomDialog>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>

      <v-layout wrap class="mt-2">
        <v-flex xs12 sm3 class="px-1">
          <div class="caption mb-2">Create By</div>
          <v-text-field
            v-model="filter.create_by"
            class="default-input"
            outline
            hide-details
            single-line
            placeholder="Create By"
          ></v-text-field>
        </v-flex>
        <v-flex xs12 sm6>
          <div class="caption mb-2">Create Date</div>
          <v-layout wrap>
            <v-flex xs12 sm6 class="px-1">
              <DatepickerCustomDialog v-model="filter.create_date_from">
                <template #default="{ computedDate }">
                  <v-text-field
                    class="default-input"
                    outline
                    name="startDate"
                    readonly
                    :value="computedDate"
                    hide-details
                    single-line
                    clearable
                    :placeholder="$t('from')"
                    @click:clear="filter.create_date_from = undefined"
                  ></v-text-field>
                </template>
              </DatepickerCustomDialog>
            </v-flex>
            <v-flex xs12 sm6 class="px-1">
              <DatepickerCustomDialog v-model="filter.create_date_to">
                <template #default="{ computedDate }">
                  <v-text-field
                    class="default-input"
                    outline
                    name="startDate"
                    readonly
                    :value="computedDate"
                    hide-details
                    single-line
                    clearable
                    :placeholder="$t('to')"
                    @click:clear="filter.create_date_to = undefined"
                  ></v-text-field>
                </template>
              </DatepickerCustomDialog>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
      <div class="text-xs-center text-sm-right mt-2">
        <v-btn outline @click="handleClearSearch">{{ $t('Clear search') }}</v-btn>
        <v-btn color="primary" @click="handleSearch">
          <v-icon class="mr-2">search</v-icon>{{ $t('Search') }}
        </v-btn>
      </div>
    </div>
    <div class="my-2">
      <div v-if="loading" class="text-xs-center">
        <v-progress-circular indeterminate color="primary" />
      </div>
      <template v-else>
        <Pagination v-model="pageNumber" :limit="limit" :total="total" @onChange="handleChangePage">
          <template v-for="campaign in campaigns">
            <div :key="campaign.id" class="z-border-red pa-2 mb-2">
              <v-layout>
                <v-flex>
                  <CampaignStatus :value="campaign.status_campaign" />
                  <!-- <toggle-button
                    :value="campaign.is_open"
                    :sync="true"
                    @change="handleChangeStatusCampaign(campaign)"
                    :color="$vuetify.theme.success"
                    :labels="{ checked: 'ON', unchecked: 'OFF' }"
                  /> -->
                  <strong>{{ campaign.name }}</strong>
                </v-flex>
                <v-flex class="text-xs-right">
                  <v-btn outline @click="handlePreviewCampaign(campaign)">
                    <v-icon class="mr-2">visibility</v-icon>{{ $t('preview') }}
                  </v-btn>
                  <v-btn outline @click="handleDeleteCampaign(campaign)"
                    ><v-icon class="mr-2">delete</v-icon>{{ $t('Delete') }}</v-btn
                  >
                  <v-btn color="primary" @click="handleEditCampaign(campaign)">
                    <v-icon class="mr-2">edit</v-icon>
                    {{ $t('edit') }}</v-btn
                  >
                </v-flex>
              </v-layout>
              <!-- <v-layout wrap>
                <v-flex xs12 sm6 class="pa-1">
                  <div class="caption mb-2">Campaign Description</div>

                  <v-text-field
                    readonly
                    class="default-input"
                    outline
                    :value="campaign.description"
                    hide-details
                    single-line
                    placeholder="Campaign Description"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6></v-flex>
              </v-layout> -->
              <v-layout wrap>
                <v-flex xs12 sm6 class="pa-1">
                  <div class="caption mb-2">Game</div>

                  <v-text-field
                    readonly
                    class="default-input"
                    outline
                    :value="campaign.game_type"
                    hide-details
                    single-line
                    placeholder="Game Type"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6>
                  <div class="caption mb-2">Camapign Period / Time</div>
                  <v-layout wrap>
                    <v-flex xs12 sm6 class="pa-1">
                      <v-text-field
                        readonly
                        class="default-input"
                        outline
                        :value="dateFormat(campaign.start_campaign)"
                        hide-details
                        single-line
                        placeholder="Start campaign"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 class="pa-1">
                      <v-text-field
                        readonly
                        class="default-input"
                        outline
                        :value="dateFormat(campaign.end_campaign)"
                        hide-details
                        single-line
                        placeholder="End campaign"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>

              <v-layout wrap>
                <v-flex xs12 sm3 class="pa-1">
                  <div class="caption mb-2">Create By</div>

                  <v-text-field
                    readonly
                    class="default-input"
                    outline
                    :value="campaign.create_by"
                    hide-details
                    single-line
                    placeholder="Create By"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm3 class="pa-1">
                  <div class="caption mb-2">Create Date</div>

                  <v-text-field
                    readonly
                    class="default-input"
                    outline
                    :value="dateFormat(campaign.created_timestamp)"
                    hide-details
                    single-line
                    placeholder="Create Date"
                  ></v-text-field>
                </v-flex>
                <!-- <v-flex xs12 sm3 class="pa-1">
                  <div class="caption mb-2">Sort Order</div>

                  <v-text-field
                    class="default-input"
                    outline
                    :value="campaign.priority"
                    hide-details
                    single-line
                    placeholder="Sort Order"
                    @blur="handleChangePriorityCampaign(campaign, $event)"
                  ></v-text-field>
                </v-flex> -->
              </v-layout>
            </div>
          </template>
        </Pagination>
      </template>
    </div>
    <v-dialog v-model="showPreview" max-width="375" persistent>
      <v-card>
        <v-card-text>
          <v-layout>
            <v-flex class="title pt-3"> Preview </v-flex>
            <v-flex class="text-xs-right">
              <v-btn
                icon
                @click="
                  showPreview = false
                  currentCampaign = null
                "
              >
                <v-icon>close</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-text>
        <div v-if="currentCampaign">
          <div
            :style="{
              backgroundImage:
                'url(\'' +
                currentCampaign.background +
                '\'),url(\'/static/img/assets/generali-game/bg.png\')',

              backgroundSize: 'cover',
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'center',
              backgroundColor: '#aa221a',
              overflowX: 'hidden',
              minHeight: '500px'
            }"
          >
            <div
              class="pt-2"
              :style="{ display: 'flex', justifyContent: 'center', alignItems: 'flex-start' }"
            >
              <img
                :src="
                  currentCampaign.banner
                    ? currentCampaign.banner
                    : `/static/img/assets/generali-game/${
                        currentCampaign.game_type == 'Spinning Wheel'
                          ? 'spinning-wheel'
                          : 'box-prize'
                      }/banner.png`
                "
                :style="{ width: '100%', maxWidth: '250px' }"
              />
            </div>

            <div v-if="currentCampaign.game_type == 'Spinning Wheel'" style="position: relative">
              <div
                :style="{
                  display: 'flex',
                  justifyContent: 'center',
                  position: 'relative',
                  paddingBottom: '37px',
                  overflow: 'hidden'
                }"
              >
                <div>
                  <img
                    src="/static/img/assets/generali-game/spinning-wheel/floor.png"
                    style="position: absolute; top: 386px; width: 100%; z-index: 1"
                  />
                  <img
                    src="/static/img/assets/generali-game/spinning-wheel/light.png"
                    style="position: absolute; top: 0; width: 100%; z-index: 1"
                  />
                  <img
                    src="/static/img/assets/generali-game/spinning-wheel/wheel.png"
                    style="position: absolute; top: 29px; left: 20px; width: 90%; z-index: 1"
                  />
                  <img
                    src="/static/img/assets/generali-game/spinning-wheel/wheel-cover.png"
                    style="width: 100%; z-index: 10; position: relative"
                  />
                </div>
              </div>
              <div
                style="
                  display: flex;
                  justify-content: center;
                  top: 399px;
                  width: 100%;
                  position: absolute;
                  z-index: 11;
                "
              >
                <v-btn
                  round
                  style="
                    cursor: initial;
                    color: white;
                    background-color: #eb2229;
                    border: 2px solid white;
                  "
                >
                  หมุน
                </v-btn>
              </div>
            </div>

            <v-layout v-else column>
              <div style="position: relative; width: 100%">
                <img
                  src="/static/img/assets/generali-game/box-prize/base.png"
                  style="position: absolute; top: 0"
                  :style="{
                    width: '300px',
                    position: 'absolute',
                    left: '50%',
                    marginLeft: '-150px',
                    top: '270px'
                  }"
                />
                <img
                  src="/static/img/assets/generali-game/box-prize/light.png"
                  style="position: absolute; top: 0"
                  :style="{
                    width: '375px',
                    position: 'absolute',
                    top: 0,
                    left: '50%',
                    right: 0,
                    marginLeft: '-187px'
                  }"
                />
                <img
                  src="/static/img/assets/generali-game/box-prize/box-front.png"
                  :style="{
                    width: '200px',
                    position: 'absolute',
                    left: '50%',
                    marginLeft: '-100px',
                    top: '120px'
                  }"
                />
                <img
                  src="/static/img/assets/generali-game/box-prize/box-top.png"
                  :style="{
                    width: '210px',
                    position: 'absolute',
                    left: '50%',
                    marginLeft: '-107px',
                    top: '40px'
                  }"
                />
              </div>

              <div
                :style="{
                  display: 'flex',
                  justifyContent: 'center',
                  marginTop: '304px',
                  width: '100%'
                }"
              >
                <v-btn
                  round
                  style="
                    cursor: initial;
                    color: white;
                    background-color: #eb2229;
                    border: 2px solid white;
                  "
                >
                  เปิด
                </v-btn>
              </div>
            </v-layout>
            <div class="text-xs-center mt-4 mb-4">
              <v-btn
                full-width
                :style="{
                  minWidth: '300px',
                  backgroundColor: '#eb2229',
                  border: '1px solid',
                  color: 'white',
                  backgroundColor: '#B40E0F',
                  borderColor: 'white'
                }"
                style="    cursor: initial;color: white; '"
                >รายละเอียด</v-btn
              ><br />
              <v-btn
                full-width
                :style="{
                  minWidth: '300px',
                  backgroundColor: '#eb2229',
                  border: '1px solid',
                  color: 'white',
                  backgroundColor: '#B40E0F',
                  borderColor: 'white'
                }"
                style="cursor: initial; color: white"
                >ข้อตกลงและเงื่อนไข</v-btn
              >
            </div>
          </div>
        </div>
      </v-card>
    </v-dialog>

    <ListSort v-if="showListSort" v-model="showListSort" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import generaliApi from '@/api/generali'
import { handleResponse, handleApiError } from '@/api/util'

import moment from 'moment'
import Pagination from '@/components/elements/Pagination2.vue'
import DatepickerCustomDialog from '@/components/elements/DatepickerCustomDialog.vue'
import ListSort from './ListSort.vue'
import CampaignStatus from './CampaignStatus'
export default {
  components: {
    Pagination,
    DatepickerCustomDialog,
    ListSort,
    CampaignStatus
  },
  props: ['currentView'],
  data() {
    return {
      loading: false,
      filter: {
        name: undefined,
        game_type: undefined,
        status: ['Active', 'Publish'],
        create_by: undefined,
        campaign_period_from: undefined,
        campaign_period_to: undefined,
        create_date_from: undefined,
        create_date_to: undefined
      },
      campaigns: [],
      currentCampaign: null,
      showPreview: false,
      showAdvanceSearch: false,
      showListSort: false,
      pageNumber: 1,
      limit: 10,
      total: 0,
      searchTimeout: null
    }
  },
  computed: {
    ...mapGetters(['selectedBot'])
  },
  watch: {
    'filter.status': function (newVal, oldVal) {
      if (newVal != oldVal) {
        if (this.searchTimeout) clearTimeout(this.searchTimeout)
        this.searchTimeout = setTimeout(() => {
          this.handleSearch()
        }, 1000)
      }
    }
  },

  async mounted() {
    this.loading = true
    await this.handleGetCampaign()
    this.loading = false
  },
  methods: {
    async handleChangePage() {
      this.loading = true
      await this.$nextTick()
      await this.handleGetCampaign()
      this.loading = false
    },
    dateFormat(date, format = 'DD/MM/YYYY HH:mm') {
      return format && date ? moment(date).format(format) : ''
    },
    handlePreviewCampaign(campaign) {
      this.currentCampaign = campaign
      this.showPreview = true
    },
    async handleChangePriorityCampaign(campaign, $event) {
      this.$store.dispatch('loading')
      try {
        const response = await generaliApi.putCampaign({
          config: {
            params: {}
          },
          data: {
            ...campaign,
            campaign_id: campaign.id,
            priority: this.numberOnly($event) > 1 ? this.numberOnly($event) : 1
          }
        })
        await handleResponse(response)
        campaign.priority = this.numberOnly($event) > 1 ? this.numberOnly($event) : 1
        await this.$nextTick()
        await this.handleGetCampaign()
      } catch (error) {
        handleApiError(error)
      }
      this.$store.dispatch('loading')
    },
    handleClearSearch() {
      this.filter = {
        name: undefined,
        game_type: undefined,
        status: ['Active', 'Publish'],
        create_by: undefined,
        campaign_period_from: undefined,
        campaign_period_to: undefined,
        create_date_from: undefined,
        create_date_to: undefined
      }
      this.handleSearch()
    },
    async handleSearch() {
      this.loading = true
      this.pageNumber = 1
      await this.handleGetCampaign()
      this.loading = false
    },
    async handleGetCampaign() {
      try {
        const response = await generaliApi.getCampaign({
          config: {
            params: {
              page_id: this.selectedBot.pageid,
              ...this.filter,
              status:
                this.filter.status && this.filter.status.length
                  ? this.filter.status.join(',').toLowerCase()
                  : undefined,
              limit: this.limit,
              offset: (this.pageNumber - 1) * this.limit,
              sort_column: 'created_timestamp',
              sort: 'desc'
            }
          }
        })
        await handleResponse(response)
        this.total = response.data.total ? response.data.total : 0
        this.campaigns = response.data.data
          ? response.data.data.map((campaign) => ({
              ...campaign,
              start_campaign_date: campaign.start_campaign
                ? moment(campaign.start_campaign).format('YYYY-MM-DD')
                : null,
              start_campaign_time: campaign.start_campaign
                ? moment(campaign.start_campaign).format('HH:mm')
                : null,
              end_campaign_date: campaign.end_campaign
                ? moment(campaign.end_campaign).format('YYYY-MM-DD')
                : null,
              end_campaign_time: campaign.end_campaign
                ? moment(campaign.end_campaign).format('HH:mm')
                : null
            }))
          : []
      } catch (error) {
        handleApiError(error)
      }
    },
    async handleDeleteCampaign(campaign) {
      try {
        const result = await this.$swal.fire({
          title: this.$t('Do you want to delete this?'),
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: this.$t('Confirm'),
          cancelButtonText: this.$t('cancel'),
          reverseButtons: true
        })
        if (result.value) {
          const response = await generaliApi.deleteCampaign({
            config: {
              params: {
                page_id: this.selectedBot.pageid,
                campaign_id: campaign.id
              }
            }
          })
          await handleResponse(response)
          this.handleGetCampaign()
          await this.$swal.fire({
            type: 'success',
            title: this.$t('Success')
          })
        }
      } catch (error) {
        handleApiError(error)
      }
    },
    handleCreateCampaign() {
      this.$emit('handleChangeView', { view: 'manage' })
    },
    handleEditCampaign(campaign) {
      this.currentCampaign = campaign
      this.$emit('handleChangeView', { view: 'manage', data: campaign })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/generalixwarroom/GameSetting/List.vue